import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {environment} from '../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';

@Component({
  selector: 'fb-testing-page',
  templateUrl: './fb-testing-page.component.html',
  styleUrls: ['./fb-testing-page.component.scss']
})
export class FbTestingPageComponent implements OnInit {
  public static readonly FB_GRAPH_API = 'https://www.facebook.com/v3.2';
  public static readonly AUTHORIZATION_SCOPE = 'instagram_basic,instagram_manage_insights,pages_show_list,email';
  private env = environment;
  public channel: FormGroup;
  private facebookAuthUrl: string;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    const facebookAppId = this.env.facebookAppId;
    const fbRedirectUri = this.env.fbRedirectUri;
    const fbAppState = this.env.fbAppState;
    this.facebookAuthUrl = `${FbTestingPageComponent.FB_GRAPH_API}/dialog/oauth?client_id=${facebookAppId}&redirect_uri=${fbRedirectUri}&state=${fbAppState}&response_type=code&scope=${FbTestingPageComponent.AUTHORIZATION_SCOPE}`;
    this.route.fragment.pipe(
      map(fragment => new URLSearchParams(fragment)),
      map(params => ({
        accessToken: params.get('access_token'),
        state: params.get('state'),
        errorCode: params.get('error_code')
      }))
    ).subscribe(res => {
      if (res.accessToken) {
        // authorize with FB success. Redirect to success page
        return this.router.navigate(['login-fb-success'], {
          queryParams: {
            access_token: res.accessToken,
            state: res.state
          }
        });
      } else if (res.errorCode) {
        // authorize with FB error. Redirect to success page
        return this.router.navigate(['login-fb-error'], {
          queryParams: {
            error_code: res.errorCode,
            state: res.state
          }
        });
      }
    });
  }

  public facebookLogin() {
    window.location.href = this.facebookAuthUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/fb-testing-page.component.ts